import { action, payload } from 'ts-action';

export const LOCALES = '[LOCALES]';
export const UPDATE_LOCALES = `${LOCALES} UPDATE_LOCALES`;

export const updateLocales = action(UPDATE_LOCALES, payload<unknown>());
